// Shared helpers for the AI Chatbot settings surface (tabs + panels).

/**
 * Pull a readable message out of an axios error — prefer the server-provided
 * one so operators see the actual cause (e.g. missing table after a deploy
 * without migrations). Mirrors the credits panel's private helper.
 */
export function extractBackendError(err: unknown): string {
  const body: unknown = (err as { response?: { data?: unknown } })?.response?.data;
  if (typeof body === "string" && body.length > 0) return body;
  if (body && typeof body === "object") {
    const obj = body as { error?: string; message?: string; title?: string };
    if (obj.error) return obj.error;
    if (obj.message) return obj.message;
    if (obj.title) return obj.title;
  }
  const message: string | undefined = (err as { message?: string })?.message;
  return message || "Something went wrong on our side. Please refresh the page and try again.";
}

/** Format a credit amount for display — grouped, floored, never negative. */
export function formatCreditAmount(credits: number): string {
  return Math.max(0, Math.floor(credits)).toLocaleString("en-US");
}
